<template>
  <show-page class="flex-lg-row flex-column">
    <template #default>
      <term-content
        :loading="loading"
        :semester="semester"
        :roadmaps="roadmaps"
      />
    </template>
    <template #sidebar>
      <term-sidebar
        :loading="loading"
        :roadmaps="roadmaps"
        :semester="semester"
        class="d-none d-md-flex"
      />
    </template>
  </show-page>
</template>

<script>
import ShowPage from "@core/components/show-page/ShowPage.vue";
import TermContent from "./Content.vue";
import TermSidebar from "./Sidebar.vue";
export default {
  components: {
    ShowPage,
    TermContent,
    TermSidebar,
  },
  data() {
    return {
      loading: false,
      semester: {},
      roadmaps: [],
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  methods: {
    getTerm() {
      this.loading = true;
      let baseUrl = Object.keys(this.userData).length ? "/panel/" : "/front/";
      this.$http
        .get(
          baseUrl +
            "semesters/" +
            this.$route.params.id +
            "?includes=roadmaps.item,faqs"
        )
        .then(async ({ data }) => {
          this.semester = await data.data;
          this.roadmaps = await data.data.roadmaps.roadmaps.map(
            (item) => item.item
          );
        })
        .then((res) => {
            this.loading = false;
        })
        .catch((err) => {
            this.loading = false;
        });
    },
  },
  async created() {
    await this.getTerm();
  },
};
</script>

<style></style>
